import { Timestamp, UpcomingPeriod, WeekDays } from '@griply/types';
import { getPeriodLabel, TranslateFunction } from '@griply/utils';
import { useMemo } from 'react';

export type UsePeriodLabelOptions = {
  period: UpcomingPeriod;
  today: Timestamp;
  weekStartsOn: WeekDays;
  dateFormat?: string;
  t: TranslateFunction;
};

export const usePeriodLabel = ({
  period,
  today,
  weekStartsOn,
  dateFormat,
  t,
}: UsePeriodLabelOptions) =>
  useMemo(
    () => getPeriodLabel({ period, today, weekStartsOn, dateFormat, t }),
    [period, today, weekStartsOn, dateFormat, t],
  );
